(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) return;

  const selectors = [
    '[data-ds-reveal]',
    'main > .shopify-section:not(:first-child) .section',
    '.product-card',
    '.collection-card'
  ];
  const nodes = [...new Set(document.querySelectorAll(selectors.join(',')))];
  nodes.forEach((node) => node.classList.add('ds-reveal-ready'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('ds-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -35px' });

  nodes.forEach((node) => observer.observe(node));
})();
